module.exports = __webpack_public_path__ + "static/media/casual-man.61b33aa7.png";